/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Policy_Default_Max_Steps_DescriptionInputs */



/**
* | output |
* | --- |
* | "The most actions a new agent may take in one run. At most {max}." |
*
* @param {Agent_Policy_Default_Max_Steps_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_default_max_steps_description = /** @type {((inputs: Agent_Policy_Default_Max_Steps_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Default_Max_Steps_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Höchstzahl an Aktionen, die ein neuer Agent in einem Lauf ausführen darf. Höchstens ${i?.max}.`)
	return /** @type {LocalizedString} */ (`The most actions a new agent may take in one run. At most ${i?.max}.`)
});